// Deadpan copy for every RejectReason (GDD §13). The short form labels a dimmed tile, the long form is the toast. A full Record, so a new reason without copy is a compile error.

import type { RejectReason } from '@taxwar/net'

export interface RejectCopy {
  readonly short: string
  readonly long: string
}

export const REJECT_COPY: Readonly<Record<RejectReason, RejectCopy>> = {
  unaffordable: { short: 'Insufficient funds', long: 'Insufficient funds. The Finance Minister has fainted again.' },
  not_your_city: { short: 'Not your city', long: 'That city is not yours. Yet. Legally.' },
  city_fallen: { short: 'City has fallen', long: 'The city is rubble. Procurement does not deliver to rubble.' },
  deploy_site_missing: { short: 'No launch site', long: 'No launch site: aircraft need the capital or an Airbase, ships need a Port.' },
  not_coastal: { short: 'Not coastal', long: 'Ports require an ocean. This city was not consulted.' },
  no_free_slot: { short: 'No free slot', long: 'No building slot free. The zoning board says no.' },
  no_target_in_sight: { short: 'Nothing in sight', long: 'Nothing worth the invoice in sight. Intelligence is still buffering.' },
  body_cap_reached: { short: 'Troop limit', long: 'Troop limit reached. The barracks have run out of chairs.' },
  strikes_in_flight_cap: { short: 'Airspace full', long: 'Too many missiles in the air. Airspace is fully booked.' },
  match_not_running: { short: 'War not running', long: 'The war is not running. Please hold.' },
  rate_limited: { short: 'Slow down', long: 'Slow down. The procurement portal is rate-limited.' },
}
